import { splitAngle } from "@/shared/utils/angle";
import { isAngleSpecItem } from "@/shared/utils/sectionSpecUnits";
import { formatMeasurement } from "@/shared/utils/measurementPrecision";
import { GAUGE_CODES } from "../constants/inspectionChecks";

interface SpecUnit {
	Code: string;
	IsDegrees?: boolean;
}

export const formatAngle = (value: number) => {
	const { Degrees, Minutes } = splitAngle(value);
	return `${Degrees}° ${Minutes}′`;
};

/** Gauges read GO/NG; every other checked item reads Yes/No. */
export const formatCheckedReading = (code: string, checked: boolean) =>
	GAUGE_CODES.has(code) ? (checked ? "GO" : "NG") : checked ? "Yes" : "No";

/** Presentation only: tolerance math and persisted decimals are never converted. */
export const formatM1SpecMeasurement = (
	value: number | null | undefined,
	item: SpecUnit,
	missing = "-",
) => {
	if (value == null) return missing;
	return isAngleSpecItem(item) ? formatAngle(value) : formatMeasurement(value);
};
